import { REWARD_PACK_TYPE, REWARD_CATEGORY } from './web_to_client'

export const getRewardCategory = (rewardType) => {
    switch (rewardType) {
    case REWARD_PACK_TYPE.STYLE_ALL:
    case REWARD_PACK_TYPE.PROJECTION_DECAL_ALL:
    case REWARD_PACK_TYPE.EMBLEM:
        return REWARD_CATEGORY.CUSTOMIZATIONS
    default:
        return null
    }
}



// WEBPACK FOOTER //
// ./helpers/rewards.js